import React, { useState } from 'react';
import styled from 'styled-components';

import UnitCardHeader from '../../../containers/dashboards/cards/UnitCardHeader';
import UnitCardHeaderButtons from './UnitCardHeaderButtons';
import FullScreenModal from './FullScreenModal';
import UnitCardResult from './UnitCardResult';

const getFullScreen = (chart, type, isShowModal, setModalVisible) => {
  let isDisableFullScreen = Object.keys(chart).length === 0;
  let onFullScreen = () => chart.fullscreen.toggle();

  if (!Object.keys(chart).length) {
    isDisableFullScreen = !isShowModal;
    onFullScreen = () => setModalVisible(true);
  }

  return {
    isDisableFullScreen,
    onFullScreen,
  };
};

const StyledCard = styled.div`
  margin: 10px;
  display: flex;
  flex-direction: column;
  border: solid 1px #999999;
  width: ${({ isFullSize }) => (isFullSize ? '100%' : 'calc(50% - 22px)')};
  height: 40vh;
  min-height: 360px;
  min-width: 632px;
`;

const UnitCard = ({ unitsExecution, unit, isExecute, hasError, ...rest }) => {
  const [chart, setChart] = useState({});

  // модальное окно для retention и users
  const [modalVisible, setModalVisible] = useState(false);

  const isShowModal = !!unitsExecution?.[unit.id] && !unitsExecution?.[unit.id].hasError;
  const { isDisableFullScreen, onFullScreen } = getFullScreen(
    chart,
    unit.type,
    isShowModal,
    setModalVisible
  );

  return (
    <StyledCard isFullSize={unit.isFullSize}>
      <UnitCardHeader unit={unit}>
        <UnitCardHeaderButtons
          chart={chart}
          onFullScreen={onFullScreen}
          isDisableFullScreen={isDisableFullScreen || isExecute}
        />
      </UnitCardHeader>

      <FullScreenModal open={modalVisible} setVisible={setModalVisible} name={unit.name}>
        <UnitCardResult
          unit={unit}
          unitsExecution={unitsExecution}
          isExecute={isExecute}
          setChart={setChart}
          hasError={hasError}
        />
      </FullScreenModal>

      <UnitCardResult
        unit={unit}
        unitsExecution={unitsExecution}
        isExecute={isExecute}
        hasError={hasError}
        setChart={setChart}
        {...rest}
      />
    </StyledCard>
  );
};

export default UnitCard;
